module.exports = __webpack_public_path__ + "img/help-icon-00.55271c7b.png";